export default function getFilenameFromS3Link(link) {
  const objectKey = decodeURIComponent(
    new URL(link).pathname.replace(/^\//, "")
  );
  const fileName = objectKey.split("/").pop();
  return fileName;
}
